module.exports = __webpack_public_path__ + "media/images/icons/alert-9b4cf26da0c07381829a4cf3c18b4f91.svg";